import * as React from "react";
import Box from "@mui/material/Box";
import { ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";

interface buttonDataProps {
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  label: string;
}

interface MonthButtonGroupProps {
  buttonData: buttonDataProps[];
  value?: string;
}

export default function MonthButtonGroup({
  buttonData,
  value,
}: MonthButtonGroupProps) {
  const [alignment, setAlignment] = React.useState(
    value ?? buttonData[0].label);
  React.useEffect(() => {
    if (value !== undefined) {
      setAlignment(value);
    }
  }, [value]);

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null
  ) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
  };

  const control = {
    value: alignment,
    onChange: handleChange,
    exclusive: true,
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        "& > *": {
          m: 1,
        },
      }}
    >
      <ToggleButtonGroup size="small" {...control} aria-label="Small sizes">
        {buttonData.map((data) => (
          <ToggleButton
            key={data.label}
            onClick={data.onClick}
            value={data.label}
            selected={alignment === data.label}
            sx={{
              color: "#000000",
              borderColor: "#000000",
              "&.Mui-selected": {
                backgroundColor: "#000000",
                color: "#ffffff",
                "&:hover": {
                  backgroundColor: "#333333",
                  color: "#ffffff",
                },
              },
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.08)",
                color: "#000000",
              },
            }}
          >
            <Typography>{data.label}</Typography>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
}
